import React from 'react';
import PropTypes from 'prop-types';

import styles from './LicenseMandate.module.scss'
import ButtonComponent from '../../atoms/Button/Button';
import signOut from '../../../assets/images/png/sign-outicon.png'
import signOutFilled from '../../../assets/svg/SignoutFilled.svg'
import { doLogout } from '../../../common/utility';
import Modal from '../../atoms/Modal';
import { testIds } from '../../../common/testData';

const LicenseMandate = ({ data }) => {
    let logoutClass = (data && data.displayContent && data.displayContent.indexOf("contract-approver-template")) ? "logoutBottom" : "logout";
    let btnVariant = logoutClass === "logoutBottom" ? "primary-white-upper" : "primary-3";
    let src = (data && data.displayContent && data.displayContent.indexOf("contract-approver-template")) ? signOutFilled : signOut;
    return (
        <Modal variant="mandate" open={true} width="668px" showClose={false}>
            <div className={styles["licenseBodyWrapper"]}>
                <div className={logoutClass}><ButtonComponent variant={btnVariant} btnText="Logout" onClick={() => { doLogout() }} /> <img src={src} alt="signOut" className={"logoutImg"} /></div>
                <div data-testid={testIds["mandate-html"]} dangerouslySetInnerHTML={{ __html: data && data.displayContent }} />
            </div>
        </Modal>
    );
};

LicenseMandate.propTypes = {
    handleClose: PropTypes.func,
    data: PropTypes.object
};
export default LicenseMandate;
